<header class="header">
  <div class="container header__wrapper">
    <div class="header__logo">
      <img src="../../assets/header/svg/header.svg" alt="header-logo" />
    </div>

    <nav class="navigation">
      <ul>
        <li>
          <a
            [routerLink]="['/superadmin', appRoutes.DASHBOARD]"
            routerLinkActive="active"
            >{{ "header.dashboard" | translate }}</a
          >
        </li>
        <li>
          <a
            [routerLink]="['/superadmin', appRoutes.CLIENT_ADMINS]"
            routerLinkActive="active"
            >{{ "header.clientAdmins" | translate }}</a
          >
        </li>
        <li [ariaDisabled]="true">
          <a
            [routerLink]="['/superadmin', appRoutes.CLIENTS]"
            routerLinkActive="active"
            >{{ "header.clients" | translate }}</a
          >
        </li>
        <li>
          <a
            [routerLink]="['/superadmin', appRoutes.BUILDINGS]"
            routerLinkActive="active"
            >{{ "header.buildings" | translate }}</a
          >
        </li>
        <li>
          <a
            [routerLink]="['/superadmin', appRoutes.LIFTS]"
            routerLinkActive="active"
            >{{ "header.lifts" | translate }}</a
          >
        </li>
        <li>
          <a
            [routerLink]="['/superadmin', appRoutes.DEVICES]"
            routerLinkActive="active"
            >{{ "header.devices" | translate }}</a
          >
        </li>
      </ul>
    </nav>

    <div class="header__buttons">
      <p>{{ userName }}</p>
      <app-profile-preview></app-profile-preview>
    </div>
  </div>
</header>
